jQuery(document).ready(function($) {
  const cartUpsellWrapper = $("[data-cart-upsell-wrapper]");
  const cartUpsellPopup = $("[data-cart-upsell-popup]");
  const cartUpsellOverlay = $("[data-cart-upsell-overlay]");

  $("[data-cart-upsell-close], [data-cart-upsell-overlay]").click(() => cartUpsellWrapper.addClass("hidden"))

  $("#cart-upsell").on("change", (el) => {
    const checked = el.target.checked;
    if (!checked) return;
    cartUpsellWrapper.removeClass("hidden")
  })

  $("#cart-popup-note").on("change", (el) => {
    const checked = el.target.checked;
    $("[data-cart-upsell-textarea]").toggleClass("hidden", !checked)
  })

  $("[data-upsell-popup-continue]").click(() => {
    const addItem = $("#cart-popup-upsell").is(":checked");
    if (addItem) {
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        data: {items: 
            [
              {
                quantity: 1, 
                id: $("[data-cart-upsell-product]").data("cart-upsell-product")
              }
            ]
          },
        success: function() {
          console.log('sdfjnl')
          updateOrderNote();
          window.getAndUpdateCart();
        },
        error: function() {}
      });
    }
    else {
      updateOrderNote();
    }
    
    cartUpsellWrapper.addClass("hidden")
  })

  function updateOrderNote() {
    const orderNote = $("#cart-popup-note").is(":checked");
    if (orderNote) {
      const note = $(".cart-upsell__textarea").val();
      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        data: {note},
        success: function() {},
        error: function() {}
      });
    }
    else {
      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        data: {note: ""},
        success: function() {
          console.log('here')},
        error: function() {}
      });
    }
  }

  $(window).scroll(function() {
    var scrollTop = $(window).scrollTop();
    var trigger = 25;

    if ($(window).width() <= 1024){
      trigger = 0;
    }

    if (scrollTop > 0){
      $('body').addClass('scrolling');
    } else {
      $('body').removeClass('scrolling');
    }
  });

  var $nextSectionArrow = $('.index-hero__next-section');
  var $indexShopSection = $('#index-shop');
  var $indexShopProducts = $indexShopSection.find('.products-grid');
  var slidesShow = 4;

  if ($('body').hasClass('template-page-ingredients')){
    slidesShow = 3;
  }

  $nextSectionArrow.click(function() {
    $("html, body").animate({ scrollTop: $indexShopSection.offset().top - 90 }, 1000);
  });

  $indexShopProducts.slick({
    dots: false,
    infinite: false,
    slidesToShow: slidesShow,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.index-images__wrap').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true
  });

  var $papers = $('.index-papers__blocks');
  var $papersCount = $('.index-papers__block').length;

  if ($papersCount > 1){
    $papers.slick({
      dots: false,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  var $productReviews = $('#product-reviews .reviews__blocks');
  var productReviewsCount = $productReviews.find('.column').length;
  var $productAwards = $('#product-reviews .award__blocks');
  var productAwardsCount = $productAwards.find('.column').length;

  if (productReviewsCount > 1){
    if (productReviewsCount === 2){
      $productReviews.addClass('desktop-dots-hidden');
    }

    $productReviews.slick({
      dots: true,
      arrows: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  if (productAwardsCount > 1){
    if (productAwardsCount === 2){
      $productAwards.addClass('desktop-dots-hidden');
    }

    $productAwards.slick({
      dots: true,
      arrows: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  var $reviewsHeading = $('.reviews__header h2');

  $reviewsHeading.click(function() {
    if (!$(this).hasClass('active')){
      $reviewsHeading.removeClass('active');
      $(this).addClass('active');
      $productReviews.toggleClass('active');
      $productAwards.toggleClass('active');
    }
  });

  // MBC

  function sliders() {
    if($(window).width() < 1024) {
      jQueryBridget( 'flickity', Flickity, $ );
      $('.c-articles__list').flickity({
        pageDots: false,
        prevNextButtons: false,
        freeScroll: true,
        contain: true,
      });
      if($('.c-articles__item').length === 3) {
        $('.c-articles__list').flickity('select', 1);
      }
    }
    $('.promo').slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      adaptiveHeight: true
    });
    $('.p-reviews__list').slick({
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
    $('.p-related__list').slick({
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
    $('.cms__slider').slick({
      arrows: false,
      dots: true
    });
    if ($('.promotion-bar__list').length) {
      $('.promotion-bar__list').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000
      });
    }
  }

  function mobileMenu() {
    if($(window).width() < 768) {
      $('.header__url').click(function(e) {
        e.preventDefault();
        $('.menu-mobile').addClass('transformed');
        $(this).closest('.header__link').addClass('active');
        $(this).closest('.header__link').find('.header__submenu').show();
      })
      $('.header__close').click(function(e) {
        console.log('close')
        $('body').removeClass('mobile-menu-visible');
      })
      $('.header__cancel').click(function(e) {
        console.log('cancel');
        $('.menu-mobile').removeClass('transformed');
        $('.header__link--parent.active').find('.header__submenu').hide();
        $('.header__link--parent.active').removeClass('active');
      })
    }
  }

  function tabletMenu() {
    const windowWidth = window.innerWidth;
    if(windowWidth < 1280 && windowWidth > 767) {
      $('.header__link--parent').click(function(e) {
        e.preventDefault();
        let index = $(this).attr('data-index');
        console.log(index);
        $('.header__submenu').each(function() {
          if($(this).attr('data-index') == index) {
            $(this).show();
          }
          else {
            $(this).hide();
          }
        })
      })
    }
  }

  function search() {
    $('.search-icon').click(function(e) {
      e.preventDefault();
      $('.search-popup').show();
      $('body').addClass('muted')
    })
    $('.search__close').click(function() {
      $('.search-popup').hide();
      $('body').removeClass('muted')
    })
  }

  function instafeed() {
    if($('.instafeed-wrap').length) {
      var target = document.querySelector('.instafeed-wrap');

      const config = {
        subtree: true,
        childList: true
      };

      const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
          if($('.instafeed-overlay ').length > 3) {
            if($(window).width() < 1200) {
              jQueryBridget( 'flickity', Flickity, $ );
              setTimeout(function() {
                $('#insta-feed').flickity({
                  pageDots: false,
                  prevNextButtons: false,
                  freeScroll: true,
                  contain: true,
                });
              }, 100)
              observer.disconnect();
            }
          }
        }
      };
      const observer = new MutationObserver(callback);
      observer.observe(target, config);
    }
  }

  function tabs() {
    $('.product__tab').eq(0).addClass('active');
    $('.product__tab-content').eq(0).addClass('active');
    if($(window).width() < 768) {
      jQueryBridget( 'flickity', Flickity, $ );
      $('.product__tabs-top').flickity({
        pageDots: false,
        prevNextButtons: false,
        freeScroll: true,
        contain: true,
      });
    }
    $('.product__tab').click(function() {
      let index = $(this).attr('data-index');
      $('.product__tab').removeClass('active');
      $(this).addClass('active');
      console.log(index);
      $('.product__tab-content').removeClass('active')
      $('.product__tab-content').each(function() {
        if($(this).attr('data-index') == index) {
          $(this).addClass('active');
        }
      })
    })
    $('.product__tab-content').each(function() {
      var h = 155;
      $('.results__item-proof').length ? h = 200 : h = 230;
      if($(this).height() >= h) {
        $(this).addClass('product__tab-content--small');
      }
    })
    $('.product__tab-content-expand').click(function() {
      $(this).closest('.product__tab-content').removeClass('product__tab-content--small').addClass('product__tab-content--expanded');
    })
    $('.product__tab-content-hide').click(function() {
      $(this).closest('.product__tab-content').addClass('product__tab-content--small').removeClass('product__tab-content--expanded');
    })
    $('.product__tab-image-text').click(function() {
      $(this).closest('.product__tab-image').addClass('active');
    })
  }

  function gallery() {
    // $('.product__gallery-small').slick({
    //   vertical: true,
    //
    // })
    $('.product__gallery-big').slick({
      arrows: true,
      dots: true,
    })
    $('.product__gallery-big').on('afterChange', function() {
      let index = $('.product__gallery-big').find('.slick-current').attr('data-slick-index')
      $('.product__thumb').removeClass('active');
      $('.product__thumb').each(function() {
        if($(this).attr('data-index') == index) {
          $(this).addClass('active');
        }
      })
    })
    $('.product__thumb').click(function() {
      $('.product__thumb').removeClass('active');
      $(this).addClass('active');
      let index = $(this).attr('data-index');
      $('.product__gallery-big').slick('slickGoTo', index);
    })
  }

  function productReviews() {
    $('.product__review-count').click(function() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $('.p-reviews').offset().top - 85
      }, 1000);
    })
  }

  function blog() {
    $('.blog__list-load').click(function() {
      $('.blog__item').addClass('visible');
      $(this).addClass('hidden');
    })
    if($('.blog__item').length > 9) {
      $('.blog__list-load').addClass('d-lg-flex')
    }
    if($('.blog__item').length > 6) {
      $('.blog__list-load').addClass('d-md-flex')
    }
    if($('.blog__item').length > 3) {
      $('.blog__list-load').addClass('d-flex')
    }


    $('.blog__bar-item').click(function(e) {
      let i = $(this).attr('data-index');
      $('.blog__bar-content').each(function(index, item) {
        if($(this).attr('data-index') !== i && $(this).hasClass('active')) {
          $(this).slideUp();
          $(this).removeClass('active');
        }
        if($(this).attr('data-index') === i) {
          $(this).slideToggle();
          $(this).toggleClass('active');
        }
      })
      $('.blog__bar-item').each(function(index, item) {
        if($(this).attr('data-index') !== i && $(this).hasClass('active')) {
          $(this).removeClass('active');
        }
        if($(this).attr('data-index') === i) {
          $(this).toggleClass('active');
        }
      })
    })

    var selectedTag = location.pathname.split('/')[4];
    $('.blog__filter').each(function() {
      if($(this).attr('data-tag') == selectedTag) {
        $(this).addClass('active');
      }
    })
    $('.blog__filter').click(function(e) {
      if($(this).hasClass('active')) {
        e.preventDefault();
        window.location.href = location.pathname.split('/').slice(0, 3).join('/')
      }
    })

    var sort = location.search.replace('?', '');
    $('.blog__sort-item').each(function() {
      if($(this).attr('data-sort') == sort) $(this).addClass('active');
    })
    if(sort == 'oldest') {
      var blogList = $('.blog__list').find('.row');
      blogList.children().each(function(i,li){blogList.prepend(li)})
    }

    $('.blog__sort-item').click(function() {
      if($(this).hasClass('active')) {
        window.location.href = location.pathname
      }
      else {
        window.location.href = location.pathname + '?' + $(this).attr('data-sort')
      }
    })
  }

  function article() {
    if($('body').hasClass('template-article')) {
      if($('.article-gallery').length) {
        var galleryImages = $('.article-gallery img').length;
        $('.article-gallery img').wrapAll('<div class="article-gallery__images">');
        $('.article-gallery-caption').prepend(
            '<div class="article-gallery-numbers">' +
              '<span class="article-gallery-current">01</span>' +
              '<span> / 0' + galleryImages +'</span>' +
            '</div>'
        )
        $('.article-gallery__images').slick({
          dots: false,
          arrows: true,
        })
        $('.article-gallery__images').on('afterChange', function(slick, currentSlide) {
          let slide = currentSlide.currentSlide + 1;
          $('.article-gallery-current').html('0' + slide)
        })
      }
    }
    if($('.article-video').length) {
      $('.article-video').append('<div class="article-video__text">\n' +
          '<img src="//cdn.shopify.com/s/files/1/0066/3060/4858/t/13/assets/play.png?v=9327069024392378608" alt="">Play the video\n' +
          '</div>')
      let src= $('.article-video').find('img').attr('alt');
      $('.article-video__text').click(function() {
        $(this).hide();
        $(this).siblings('img').hide();
        $(this).closest('.article-video').append('<iframe src="' + src + '?autoplay=1&loop=1&autopause=0">')
      })
    }
    $('.article__share-btn').click(function() {
      $('.share-overlay').addClass('active');
      $('body').addClass('muted');
    })
    $('.share-popup__close').click(function() {
      $('.share-overlay').removeClass('active');
      $('body').removeClass('muted');
    })
  }

  function cmsPages() {
    if($(window).width() < 768) {
      $('.cms table tr').eq(0).remove();
      $('.cms table tr').each(function() {
        let td3 = $(this).find('td').eq(2).text();
        let td2 = $(this).find('td').eq(1).text();
        $(this).find('td').eq(2).remove();
        $(this).find('td').eq(1).remove();
        $(this).find('td').eq(0).append('<span class="td2">' + td2 + '</span>')
        $(this).find('td').eq(0).append('<span class="td3">' + td3 + '</span>')
      })
    }
    if($(window).width() >= 768 && $(window).width() < 1200) {
      $('.cms table tr').each(function(index, item) {
        if(index === 0) {
          let td3 = $(this).find('td').eq(2).text();
          $(this).find('td').eq(1).html($(this).find('td').eq(1).text() + ' / ' + td3);
          $(this).find('td').eq(2).remove();
        }
        else {
          let td3 = $(this).find('td').eq(2).text();
          $(this).find('td').eq(1).append('<span class="td3">' + td3 + '</span>')
          $(this).find('td').eq(2).remove();
        }
      })
    }
    if($('.cms-video').length) {
      $('.cms-video').append('<div class="cms__video__text">\n' +
          '<img src="//cdn.shopify.com/s/files/1/0066/3060/4858/t/13/assets/play.png?v=9327069024392378608" alt="">Play the video\n' +
          '</div>')
      let src= $('.cms-video').find('img').attr('data-video');
      $('.cms__video__text').click(function() {
        $(this).hide();
        $(this).siblings('img').hide();
        $(this).closest('.cms-video').append('<iframe src="' + src + '?autoplay=1&loop=1&autopause=0">')
        $(this).closest('.cms-video').addClass('active');
      })
      $('.cms__tab-title').click(function() {
        $(this).closest('.cms__tab').toggleClass('active').find('.cms__tab-content').slideToggle();
      })
    }
    if($('.ingredients__tabs').length) {
      $('.ingredients-tab table').wrap('<div class="ingredients-tab-content">');
      $('.ingredients-tab h2').click(function() {
        if($(this).closest('.ingredients-tab').hasClass('active')) {
          $(this).closest('.ingredients-tab').toggleClass('active');
          $(this).siblings('.ingredients-tab-content').slideToggle();
        }
        else {
          $('.ingredients-tab.active').find('.ingredients-tab-content').slideToggle();
          $('.ingredients-tab.active').removeClass('active');
          $(this).closest('.ingredients-tab').toggleClass('active');
          $(this).siblings('.ingredients-tab-content').slideToggle();
        }
      })
    }
  }

  function productVariants() {
    if($('.template-product')) {
      $('.product__price').text($('#productSelect').find('option:selected').attr('data-pricenocurrency'))
    }
    $('#productSelect').change(function() {
      $('.product__price').text($(this).find('option:selected').attr('data-pricenocurrency'))
    })
  }

  function faqTabs() {
    const selectors = {
      productTab: '.faq-product__tab',
      productTabContent: '.faq-product__tab-content',
    }
    $(selectors.productTab).on('click', function(e) {
      e.preventDefault();
      if($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).next().slideUp()
      } else {
        $(selectors.productTab).removeClass('active')
        $(selectors.productTabContent).slideUp()
        $(this).addClass('active');
        $(this).next().slideDown()
      }
    })

  }

  $('body').on('click', '#ep-modal-button', function(e){
    e.preventDefault();
    window.location.replace("/cart");
  })

  function giftMesage() {
    $('#notes').click(function(){
      if ($(this).is(':checked')){
        $('.gift-note-message').show(100);
      } else {
        $('.gift-note-message').hide(100);
      }
    });
  }

  
  function initGiftMessage () {
    let giftMessage = window.localStorage.getItem('gift-note');
    if(giftMessage) {
      $(".gift-note").val(giftMessage);
      $('#notes').prop('checked', true);
      $('.gift-note-message').show(100);
    } else {
      $('#notes').prop('checked', false);
      $(".gift-note").val("");
      $('.gift-note-message').hide(100);
    }

    $(".gift-note").on('change keyup paste', function() {
      $(this).val() ? window.localStorage.setItem('gift-note', $(this).val()) :  window.localStorage.removeItem('gift-note');
    });
  }

  $('body.template-cart').on('click','.btn-checkout',function(e){
    e.preventDefault();
    var regex = /^[A-Za-z0-9.,!’ ]+$/
    var isValid = regex.test($('.gift-note').val());
    if (isValid || $('.gift-note').val()=="") {
      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        data: {note: $('.gift-note').val()},
        success: function(result) { 
          window.localStorage.removeItem('gift-note');
          initGiftMessage();
          window.location.href = "https://wildsmithskin.com/checkout";
        },
        error: function(jqxhr, status, exception) {
          console.log(exception);
        }
      });

    } else {
      $('.gift-note-message__error').text('Please, remove special characters from message to checkout');
    }
  });
  
  $('body').on('keyup','.gift-note',function(e){
    var regex = /^[A-Za-z0-9.,!’ ]+$/
    var isValid = regex.test($('.gift-note').val());
    if (isValid || $('.gift-note').val()=="") {
      $('.gift-note-message__error').text('');
    } else {
      $('.gift-note-message__error').text('Please, remove special characters from message to checkout');
    }
  });

  function removeSampleSelection () {
    $("body").on('click',".btn-checkout", function() {
      localStorage.removeItem("selectVariants");
    });
  }


  sliders();
  mobileMenu();
  tabletMenu();
  search();
  instafeed();
  tabs();
  gallery();
  productReviews();
  blog();
  article();
  cmsPages();
  productVariants();
  faqTabs();
  initGiftMessage();
  giftMesage();
  removeSampleSelection();
});

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

$.get("https://ipinfo.io/json", function (response) {
  if(response.country != 'GB' && getCookie('language-modal') != '1') {
    $('#location-wrapper').fadeIn();
  }
}, "jsonp");

$().ready(function() {
  
  $('#modal-location .stay').on('click', function(e) {
    e.preventDefault();
    $('#location-wrapper').fadeOut();
    setCookie('language-modal', '1');
  });
  
});

